const uuid = () =>  Date.now().toString(36) + Math.random().toString(36).substring(2);

class Polygon {
  constructor(points,id) {
    this.points = points;
    this.polygon = null;
    this.color= null;
    this.id = id || uuid();
    this.paths = this.getCoordinates()
  }

  formatePath() {
    return this.points.map(([latitude, longitude]) => {
      return { latitude, longitude }
    })
  }

  getPath() {
    return this.points;
  }

  getPathStr() {
    return this.points.map(p => `(${p.join(',')})`).join('-');
  }

  getCoordinates() {
    return this.points.map(([lat, lng]) => {
      return {
        lat: lat,
        lng: lng
      };
    });
  }

  draw({ color } = {}){
    color = color || '#ff0000';
    this.color = color;

    const currentPolygon = {
      paths: this.paths,
      strokeColor: color,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: color,
      fillOpacity: 0.35,
    }

    return currentPolygon
  }

  setPolygonObj(polygon) { 
    this.idk = polygon;
  }

  remove() {
    this.polygon.setMap(null);
  }
}

module.exports = { Polygon }